import manageNav from '../../../../../assets/images/support/supervision-meeting/manage-nav.png';
import providersList from '../../../../../assets/images/support/supervision-meeting/providers-list.png';
import manageDetails from '../../../../../assets/images/support/supervision-meeting/manage-details.png';
import addActivity from '../../../../../assets/images/support/supervision-meeting/add-activity.png';
import meetingForm from '../../../../../assets/images/support/supervision-meeting/meeting-form.png';

export const content = `If you're a collaborating physician, use **Manage** to record a completed meeting with your supervisee, including the state, date and time, duration, and communication method.

> The screenshots below use sample names, dates, and states. Yours may be different.

## Step 1: Open Manage

Log in to your provider account. In the top navigation, select [**Manage**](/collaboration/manage) (the people icon).

![Select Manage in the top navigation](${manageNav})

## Step 2: Choose your supervisee

Under **Providers**, select the supervisee you met with. Use **Search providers** or the **All States** filter to help find them.

![Select your supervisee under Providers](${providersList})

## Step 3: Review Manage Details

On the supervisee's page, review **Manage Details** for the state and **Next Supervision Meeting Due** date.

![Manage Details shows when the next supervision meeting is due](${manageDetails})

## Step 4: Add a supervision meeting

Select **Add Activity**, then choose **Supervision Meeting** from the dropdown.

![Select Add Activity, then Supervision Meeting](${addActivity})

## Step 5: Enter the meeting details

* **State:** Select the state for this meeting record.
* **Date and Time of Meeting:** Enter when the meeting took place.
* **Duration (minutes):** Enter the meeting length in minutes.
* **Method of Communication:** Select **Video call**, **Phone call**, or **In person**.

![Enter the meeting details](${meetingForm})

## Step 6: Review, sign, and submit

Check that the meeting details are accurate, then select **Sign and Submit** at the bottom of the form. The meeting appears in the supervisee's **Activity** panel.

## Related articles

* [How do I view the NPs I supervise?](/support/articles/supervised-nps)
* [How do I complete chart reviews?](/support/articles/chart-reviews)
`;
